import { SandboxItemReadDtoDispatchTypeEnum } from "@/config/apiClient";
import { type DeliverySummaryProps } from "./DeliverySummary.types";
import { DispatchFileSummary } from "./DispatchFileSummary";
import { ManualDispatchSummary } from "./ManualDispatchSummary";

export const DeliverySummary = ({ orderItem }: DeliverySummaryProps) => {
  if (
    orderItem.sandboxItem.dispatchType ===
    SandboxItemReadDtoDispatchTypeEnum.DispatchFiles
  ) {
    return <DispatchFileSummary orderItem={orderItem} />;
  }

  return <ManualDispatchSummary orderItem={orderItem} />;
};
